<template>
    <div class="h-screen pos-relative" ref="container" @wheel="onScroll">
        <div
            class="pos-fixed pos-left pos-right z-1"
            :style="{
                transition: `top ${animationDuration}ms`,
                top: `-${value * 100}vh`,
            }"
        >
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FullPageScroller',

        props: {
            sectionsCount: Number,
            value: Number,
            enableScroll: Boolean,
        },

        data() {
            return {
                currentSection: 0,
                gapHeight: 100,
                isListeningScroll: true,
                animationDuration: 750,
            };
        },

        watch: {
            currentSection(to) {
                this.$emit('input', to);
            },

            value(to) {
                this.currentSection = to;
            },
        },

        mounted() {
            const isTouchScreen =
                'ontouchstart' in window ||
                (window.matchMedia && window.matchMedia('(pointer:coarse)').matches);

            if (isTouchScreen && this.$refs.container) {
                let startY = null;

                const touchStartHandler = (e) => {
                    startY = e.touches[0].clientY;
                };

                const touchEndHandler = (e) => {
                    if (this.enableScroll && startY !== null) {
                        const deltaY = e.changedTouches[0].clientY - startY;

                        if (deltaY > 0) {
                            this.previousSection();
                        } else if (deltaY < 0) {
                            this.nextSection();
                        }
                    }

                    startY = null;
                };

                this.$refs.container.addEventListener('touchstart', touchStartHandler);
                this.$refs.container.addEventListener('touchend', touchEndHandler);
            }
        },

        methods: {
            onScroll(event) {
                if (!this.isListeningScroll || !this.enableScroll) return;

                if (event.deltaY > 0) {
                    this.nextSection();
                } else {
                    this.previousSection();
                }

                this.isListeningScroll = false;

                setTimeout(() => (this.isListeningScroll = true), this.animationDuration + 250);
            },

            previousSection() {
                if (this.currentSection === 0) return;
                this.currentSection--;
            },

            nextSection() {
                if (this.currentSection === this.sectionsCount - 1) return;
                this.currentSection++;
            },
        },
    };
</script>
